<template>
  <div class="the-flex-bit-integrated-button">
    <AppButtonText
      class="visible-button"
      :text="text"
      :button-style="buttonStyle"
      :size="size"
      @click.native="handleButtonClick"
    />
    <div
      :id="flexbitButtonId"
      ref="flexBitButtonContainer"
      class="hidden-button"
    />
  </div>
</template>
<script>
import AppButtonText from '@/components/UIKit/Standard/Atoms/AppButton/AppButtonText.vue'
import sizes from '@/constants/ui-kit/standard/sizes'
import styles from '@/constants/ui-kit/standard/styles'

export default {
  name: 'TheFlexBitIntegratedButton',
  components: {
    AppButtonText,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    flexbitButtonId: {
      type: String,
      required: true,
    },
    flexbitEncryptedPayload: {
      type: String,
      required: true,
    },
    flexbitPublicKey: {
      type: String,
      required: true,
    },
    buttonStyle: {
      type: String,
      default: styles.PRIMARY,
      validator: (value) => Object.values(styles).includes(value),
    },
    size: {
      type: String,
      default: sizes.SM,
      validator: (value) => Object.values(sizes).includes(value),
    },
  },
  mounted() {
    this.initializeFlexbitButton()
  },
  methods: {
    handleButtonClick() {
      this.$refs.flexBitButtonContainer.querySelector('button').click()
    },
    initializeFlexbitButton() {
      const script = document.createElement('script')
      script.src = 'https://testnegocios.flexbit.app/sdk.min.js'
      script.onload = () => {
        if (window.MySDK) {
          window.MySDK.renderButton({
            selector: `#${this.flexbitButtonId}`,
            encryptedPayload: this.flexbitEncryptedPayload,
            publicKey: this.flexbitPublicKey,
          })
        }
      }
      document.body.appendChild(script)
    },
  },
}
</script>

<style lang="scss" scoped>
.the-flex-bit-integrated-button {
  .hidden-button {
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    opacity: 0;
    pointer-events: none;
  }
  .visible-button {
    position: relative;
    width: 100%;
  }
}
</style>
